import script from "./PlatformFeedElement.vue.js?vue&type=script&lang=js!=!../../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PlatformFeedElement.vue?vue&type=script&lang=js"
export * from "./PlatformFeedElement.vue.js?vue&type=script&lang=js!=!../../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PlatformFeedElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-components/render-engine/components/production/elements/dynamic-app-elements/display/PlatformFeedElement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3db9ce3a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3db9ce3a', __exports__)) {
    api.reload('3db9ce3a', __exports__)
  }
  
}


export default __exports__